import axios from 'axios';
import { baseUrlDev, urlApiAsesoria } from '../Config/baseUrl';
import { IUser } from '../Interfaces/IUser';
import { IFormUsuario, IResultadoAPI, IInicioAPI } from '../Interfaces/IFormUsuario';

// const baseURL = baseUrlProduction;

const config = {
  headers: {
    'Content-Type': 'application/json',
  },
};

export const sendUserData = (data: IUser) => {
  return axios.post(urlApiAsesoria + 'retoAsesoria/ingresar', data, config);
};

export const sendVideoUsuario = (data: any) => {
  return axios.post(urlApiAsesoria + 'retoAsesoria/subirVideo', data)
}

export const sendFormUsuario = (data: IFormUsuario) => {
  return axios.post(urlApiAsesoria + 'retoAsesoria/ActualizarData', data, config);
};

export const inicioService = (data: IInicioAPI ) => {
  return axios.post(urlApiAsesoria + 'retoAsesoria/Inicio', data, config);
};
export const resultadoService = (data: IResultadoAPI ) => {
  return axios.post(urlApiAsesoria + 'retoAsesoria/resultado', data, config);
};
export const subirVideoService = (data: any) => {
  return axios.post(urlApiAsesoria + 'retoAsesoria/subirVideo', data, config);
}
